// extracted by mini-css-extract-plugin
export default {"controls":"DateNavigation_controls__ysE6n","backButton":"DateNavigation_backButton__qirjE","nextButton":"DateNavigation_nextButton__uGW8a","select":"DateNavigation_select__x-PaW"};